import { createSelectorCreator, defaultMemoize } from 'reselect';
import * as _ from 'lodash';
import {ActionsManagerProps} from "./ActionsManagerConsts";

export const createDeepEqualSelector = createSelectorCreator(
  defaultMemoize,
  _.isEqual
);

export const getActionTypes = (state, props: ActionsManagerProps) => props.types;
export const getActionDisplayType = (state, props: ActionsManagerProps) => props.displayType;
export const getActionObjects = (state, props: ActionsManagerProps) => props.objects;
